class LisboaMapHelpers {
  constructor(tileserver, map) {
    this.tileserver = tileserver;
    this.map = map;
  }

  flyTo(coords, zoom) {
    this.map.flyTo({
      center: [coords[1], coords[0]],
      zoom: zoom,
    });
  }

  addTrack(geojson, width) {
    // Trick to be able to pass this.map downstream
    let scopedMap = this.map;
    fetch(geojson)
      .then((data) => data.json())
      .then((track) => {
        scopedMap.on("load", function () {
          scopedMap.addSource("route", {
            type: "geojson",
            data: track.features[0],
          });
          scopedMap.addLayer(
            {
              id: "route",
              type: "line",
              source: "route",
              layout: {
                "line-join": "round",
                "line-cap": "round",
              },
              paint: {
                "line-color": "#888",
                "line-width": width,
              },
            },
            "place_label_other"
          );
        });
      });
  }

  addParroquias(data) {
    let features = data.map((el) => ({
      type: "Feature",
      properties: {
        name: el.text,
      },
      geometry: {
        coordinates: [el.coords[1], el.coords[0]],
        type: "Point",
      },
    }));

    let geojson = { type: "FeatureCollection", features };
    let img = new Image(24, 24);
    // SVG church Icon from iconmonstr
    img.src =
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yMSAyNGgtMTh2LTQuMTQ0bDQtMy41MzZ2LTMuOWw1LTQuNDIgNSA0LjQydjMuOTA0bDQgMy41MzZ2NC4xNHptLTctMXYtM2MwLTEuMTA0LS44OTYtMi0yLTJzLTIgLjg5Ni0yIDJ2M2g0em00LTkuODQ5bDYgNS4zNTYtMS4zMjggMS40OTMtNC42NzItNC4xODR2LTIuNjY1em0tMTIgMGwtNiA1LjM1NiAxLjMyOCAxLjQ5MyA0LjY3Mi00LjE4NHYtMi42NjV6bTcgMS44NDl2LTJjMC0uNTUyLS40NDgtMS0xLTFzLTEgLjQ0OC0xIDF2Mmgyem0tNC0xM2gydi0yaDJ2MmgydjJoLTJ2Ljc1MWw3IDYuMjQ5LTEuMzI4IDEuNDkzLTYuNjcyLTUuOTc1LTYuNjcyIDUuOTc1LTEuMzI4LTEuNDkzIDctNi4yMnYtLjc4aC0ydi0yeiIgZmlsbD0iaHNsKDAsIDAlLCAxMyUpIiAvPjwvc3ZnPg==";

    img.onload = () => this.map.addImage("parroquia", img);

    // Use arrow function to enforce 'this' binding to current context
    this.map.on("load", () => {
      this.map.addSource("parroquias-data", { type: "geojson", data: geojson });
      this.map.addLayer({
        id: "parroquias",
        type: "symbol",
        source: "parroquias-data",
        minzoom: 12,
        layout: {
          "icon-image": "parroquia",
          "icon-size": [
            "interpolate",
            ["exponential", 0.5],
            ["zoom"],
            12,
            0.5,
            15,
            1,
          ],
          "text-size": [
            "interpolate",
            ["exponential", 0.5],
            ["zoom"],
            12,
            11,
            15,
            14,
          ],
          "text-field": ["format", ["get", "name"]],
          "text-font": ["Metropolis Regular", "Noto Sans Regular"],
          "text-anchor": "top",
          "text-radial-offset": 2,
        },
        paint: {
          "text-color": "hsl(0, 0%, 13%)",
          "text-halo-blur": 0,
          "text-halo-color": "rgba(255,255,255,0.75)",
          "text-halo-width": 2,
        },
      });
    });
  }
}
